import React, { useState, useEffect } from 'react';
import { toPdf_pages, toPdfAuto } from './components/toPdf';
import './components/ModalDialog.css';
import './spinner.css';
import Order from './records/Order';
import Invoice from './records/Invoice';
import FullQuote from './records/FullQuote';

const MenuView = ({ quoteId, fkCustomerId, fkUserId, viewItem, label = 'view...' }) => {
    const [contextMenu, setContextMenu] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedModal, setSelectedModal] = useState(null);  // Track which modal
    const [isLoading, setIsLoading] = useState(false);

    const handlePdfDownload = async () => {
      setIsLoading(true);
      try {
        // toPdfAuto picks server-side vs legacy based on USE_PDF_SERVER (constants.js).
        await toPdfAuto({
            container: ".pdf-capture",
            filename: `quote-${quoteId || "document"}`,
        });
      } finally {
        setIsLoading(false);
      }
    };

    const handleClick = (event) => {
        if (event.target.classList.contains("clickable-div")) {
            event.stopPropagation();
            setContextMenu({
                mouseX: event.clientX + 2,
                mouseY: Math.max(event.clientY - 135, 10),
            });
        }
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const handleMenuItemClick = (route) => {
        setSelectedModal(route);  // Set the selected modal
        setShowModal(true);
        handleClose();
    };

    useEffect(() => {
        const handleOutsideClick = () => {
            handleClose();
        };
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <div className="content-container1">
            <div className="clickable-div" onClick={handleClick}>{label}</div>

            {contextMenu && (
                <ul
                    className="context-menu"
                    style={{
                        top: `${contextMenu.mouseY}px`,
                        left: `${contextMenu.mouseX}px`,
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/order')}>Order</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/orderwithnodetails')}>Order with no details</li>
                    <li className="context-menu-item" onClick={() => handleMenuItemClick('/invoice')}>invoice</li>
                </ul>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content-modal-dialog" onClick={(e) => e.stopPropagation()}>
                        
                        {selectedModal === '/invoice' && (
                        <Invoice quoteId={quoteId} />
                        )}
                        {selectedModal === '/order' && (
                        <FullQuote quoteId={quoteId} showLinePrices={true} documentType = 'Order' />
                        )}
                        {selectedModal === '/orderwithnodetails' && (
                        <FullQuote quoteId={quoteId} showLinePrices={false} documentType = 'Order' />
                        )}
                        <br></br>
                        <div className="toolbar">
                            <button className={`toolbar-button`} onClick={() => setShowModal(false)}>Close</button>
                            <button
                                className={`toolbar-button ${isLoading ? "loading" : ""}`}
                                onClick={handlePdfDownload}
                                disabled={isLoading}
                            >
                            {isLoading ? (
                                <span className="spinner"></span>
                            ) : (
                                "📄 PDF"
                            )}
                            </button>
                        </div>
                    </div>
                </div>

            )}
        </div>
    );
};

export default MenuView;
